import { diagramUrl, shareUrlFor, caseStudyDiagramUrl, caseStudyShareUrl } from '../sysDesignApi';
import { CATEGORY_META, CASE_STUDY_CATEGORY_META } from '../seo/libraryMeta';

/*
 * The libraries rendered by the SystemDesigns and SystemDesignDetail pages.
 * Case studies are the same kind of page as a system design — same stack,
 * same diagram, same gate — so they reuse those two pages with this
 * description instead of a copy of each.
 *
 * `ns` is the i18n namespace tried first; any key it does not define falls
 * back to `systemDesigns`, so a library only spells out what differs.
 */
export const SYSTEM_DESIGNS = {
  kind: 'system-designs',
  ns: 'systemDesigns',
  basePath: '/system-designs',
  categories: CATEGORY_META,
  diagramUrl,
  shareUrl: shareUrlFor,
  event: 'system_design',
  generatorPath: '/system-designs/generate',
};

export const CASE_STUDIES = {
  kind: 'case-studies',
  ns: 'caseStudies',
  basePath: '/case-studies',
  categories: CASE_STUDY_CATEGORY_META,
  diagramUrl: caseStudyDiagramUrl,
  shareUrl: caseStudyShareUrl,
  event: 'case_study',
  generatorPath: null,
};

/** t() for a library: its own key first, then the system-design one. */
export const libraryT = (t, lib) => (key, opts) => t([`${lib.ns}.${key}`, `systemDesigns.${key}`], opts);
